import React, { Component } from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Card } from 'react-bootstrap'

class HtmlView extends Component {

	render() {

		return (<Card className="claims">
			<Card.Body>			

				<div dangerouslySetInnerHTML={{ __html: this.props.html }} />			
				
			</Card.Body>
		</Card>);
	}
}

const mapStateToProps = (state) => {
	return {
		...state.action.actionData,
	};
};

export default connect(
	mapStateToProps,
	dispatch => bindActionCreators({}, dispatch)
)(HtmlView);



// WEBPACK FOOTER //
// ./src/components/Actions/HtmlView.js